const QUERY = '.site-scroll-top';
const DELAY = 1000;

/**
 * This feature is used to setup scroll to top button behavior
 * 
 * @class ScrollToTop
 * @param {string} [query]
 * @param {number} [delay]
 */

export default class ScrollToTop {
    constructor(query = QUERY, delay = DELAY) {
        const el = document.querySelector(query);
        if (!el) throw new Error('Scroll to top button not found');

        this.el = el;
        this.delay = delay;

        this.init();
    }

    init() {
        this.handleClick();
    }

    handleClick() {
        this.el.addEventListener('click', (event) => {
            event.stopPropagation();

            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }, this.delay);
        });
    }
}

/**
 * Usage example
 * 
 * import ScrollToTop from 'components/scroll-top';
 * 
 * new ScrollToTop('.site-scroll-top', 500);
 * 
 */
